import { render } from "./RedirectItemSection.vue?vue&type=template&id=a55036a8&ts=true"
import script from "./RedirectItemSection.vue?vue&type=script&lang=ts"
export * from "./RedirectItemSection.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__